import { t } from "i18next";
import { isoToDate } from "../../helpers/helpers";
import { parseISO } from "date-fns";

export const colorRes = (res) => {
    const keyword = res.toLowerCase();
    const colors = {
        emp: 'colorbk-emp-strong',
        veh: 'colorbk-veh-strong',
        vis: 'colorbk-visit-strong',
        vehvis: 'colorbk-visit-strong',
    }
    return colors[keyword];
}

export const getIconByResoruce = (res) => {
    const keyword = res.toLowerCase();
    const icon = {
        emp: 'emp-black-bk-gray-icon.svg',
        veh: 'car-black-bk-gray-icon.svg',
        vis: 'visit-grey-bk-white-icon.svg',
        vehvis: 'car-black-bk-gray-icon.svg',
    }
    return icon[keyword];
}

export const getTranlationByKey = (key) => {
    const keyword = key.toLowerCase();
    const translation = {
        emp: t('EMP'),
        veh: t('VEH'),
        vis: t('VISIT'),
        vehvis: t('VEH'),
    }
    return translation[keyword];
}

export const getDateOrTimeToReport = (dateAndTimeString, type, withSeconds = false) => {

    if (type === 'DATE') {

        const date = dateAndTimeString.slice(0, 8);

        return isoToDate(date);
    }

    const hour = dateAndTimeString.slice(8, 10);

    const minutes = dateAndTimeString.slice(10, 12);

    if (withSeconds) {
        const seconds = dateAndTimeString.slice(12, 14);
        return `${hour}:${minutes}:${seconds}00`;
    } else {
        return `${hour}:${minutes}`;
    }
}

export const getTimeDiference = (entryValue, departureValue) => {

    let entryDate = parseISO(isoToDate(entryValue, 'YYYYMMDD', '-'));
    let departureDate = parseISO(isoToDate(departureValue, 'YYYYMMDD', '-'));

    // Verifica si la fecha de entrada es mayor que la fecha de salida
    if (entryDate > departureDate) {
        // Intercambia las fechas si la fecha de entrada es mayor
        [entryDate, departureDate] = [departureDate, entryDate];
    }

    // Calcula la diferencia en milisegundos
    const diferenciaEnMilisegundos = departureDate - entryDate;

    // Calcula la diferencia en horas y minutos
    const hours = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60));
    const minutes = Math.floor((diferenciaEnMilisegundos % (1000 * 60 * 60)) / (1000 * 60));

    // Retornar la diferencia en formato "X hs Y min"
    return `${hours} hs ${minutes} min`;
}
export const getDateYearMonthDay = (dateInFormatUtc) => {
    const date = new Date(dateInFormatUtc);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}${month}${day}000000`;
}
export const getToday = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`
}
export const getCurrentDateWithTimeInNumbers = (target) => {
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    const hour = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');

    if (target === 'DATETIME') {
        return `${year}${month}${day}${hour}${minutes}${seconds}`;
    }
    if (target === 'DATETIMECERO') {
        return `${year}${month}${day}000000`;
    }

    return `${year}${month}${day}`;
}

export const convertNumbersInDateUtc = (dateString) => {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hour = dateString.slice(8, 10);
    const minutes = dateString.slice(10, 12);

    const dateUtc = `${year}-${month}-${day}T${hour}:${minutes}:00.000Z`;
    return dateUtc;
}
export const getHourAndMinutesFromSeconds = (seconds) => {
    // Calculate hours and remaining seconds
    const hours = Math.floor(seconds / 3600);
    const remainingSeconds = seconds % 3600;

    // Calculate minutes
    const minutes = Math.floor(remainingSeconds / 60);
    const singularHour = hours === 1 ? 'HOUR' : 'HOURS';
    const singularMin = minutes === 1 ? 'MINUTE' : 'MINUTES';

    return `${hours} ${t(singularHour).toLowerCase()} ${minutes} ${t(singularMin).toLowerCase()}`
}